import React, { useState } from 'react';
import { Button } from './ui/button';
import { ArrowRight, Mail, Phone } from 'lucide-react';
import PartnershipModal from './PartnershipModal';
import ContactModal from './ContactModal';

const PartnershipCTASection = () => {
  const [showPartnershipModal, setShowPartnershipModal] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);

  return (
    <section className="py-24 bg-white relative overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#0077BE]/5 via-transparent to-[#00B4D8]/5"></div>
      
      <div className="max-w-5xl mx-auto px-6 relative z-10">
        <div className="p-12 md:p-16 rounded-3xl backdrop-blur-2xl bg-gradient-to-br from-white/80 to-white/60 border border-white/50 shadow-2xl text-center">
          <h2 className="text-5xl md:text-6xl font-bold text-[#0B0F14] mb-6 leading-tight">
            A Partner You Can Trust<br />With Every Ride
          </h2>
          <p className="text-xl md:text-2xl text-[#5F6B7A] mb-12 leading-relaxed max-w-3xl mx-auto">
            We are not a vendor—we are an extension of your student support system.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <Button 
              size="lg"
              onClick={() => setShowPartnershipModal(true)}
              className="bg-gradient-to-r from-[#0077BE] to-[#00B4D8] text-white hover:shadow-2xl text-lg px-10 py-7 rounded-2xl font-semibold transition-all duration-300 hover:scale-105 group"
            >
              Start a Partnership
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Button>
            <Button 
              size="lg" 
              variant="outline"
              onClick={() => setShowContactModal(true)}
              className="border-2 border-[#0077BE] text-[#0077BE] hover:bg-[#0077BE] hover:text-white text-lg px-10 py-7 rounded-2xl font-semibold transition-all duration-300 hover:scale-105"
            >
              Contact Our Team
            </Button>
          </div>

          {/* Contact Info */}
          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center text-[#5F6B7A]">
            <div className="flex items-center gap-2">
              <Mail className="w-5 h-5 text-[#0077BE]" />
              <span className="font-semibold">365@transportationgroup.org</span>
            </div>
            <div className="hidden sm:block w-1 h-1 rounded-full bg-[#5F6B7A]"></div>
            <div className="flex items-center gap-2">
              <Phone className="w-5 h-5 text-[#0077BE]" />
              <span className="font-semibold">209-200-9884</span>
            </div>
          </div>
        </div>
      </div>
      
      {/* Modals */}
      <PartnershipModal 
        open={showPartnershipModal} 
        onOpenChange={setShowPartnershipModal}
      />
      <ContactModal 
        open={showContactModal} 
        onOpenChange={setShowContactModal}
      />
    </section>
  );
};

export default PartnershipCTASection;
